import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddContinualImprovement.module.css";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";
import { useCertification } from "../../../../hooks/useCertification";

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="11.1"
          title="Procedure and/or Process for Continual Improvement"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note: Improvement activities must be identified within the
                  pre-examination, examination, and post-examination processes.
                  Laboratory management shall ensure that the laboratory
                  participates in continual improvement activities that
                  encompass relevant areas and outcomes of patient care and
                  results records
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Identification of improvement activities within the laboratory management system;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Development and documentation of improvement plans;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Communication of improvement plans and related goals to relevant personnel;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Implementation of action plans;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Recording of improvement plans;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Evaluation of effectiveness of actions taken.",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="11.2"
          title="Implementation of Continual Improvement of Management System"
          questions={[
            {
              content: (
                <>
                  Does the laboratory identify and undertake continual quality
                  improvement activities?
                  <br />
                  Note: The laboratory should use its management review
                  activities to continually improve its laboratory management
                  system by comparing its actual performance to its intentions
                  stated in the quality policy and objectives
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="11.3"
          title="Communication of Continual Improvement Activities"
          questions={[
            {
              content: (
                <>
                  Are the outcomes of continual improvement activities
                  communicated to laboratory management, personnel, and users?
                  <br />
                  Note 1: The communication can be done using graphical tools
                  (such as charts, graphs, tables) and in personnel and
                  management meetings. <br />
                  Note 2: Examples of graphical tools commonly used for this
                  purpose include LJ charts, Pareto charts, cause-and-effect
                  diagrams, frequency histograms, trend graphs, and flow charts.
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
      </>
    ),
  },
];

const AddContinualImprovement = () => {
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const { user, token } = useAuth();
  const [status, setStatus] = useState(null);

  const { labId, questionnaireId } = useParams(); // ✅ get questionnaireId too

  const editable = questionnaireId ? status === "Not Attached" : true;

    const {
      formData: answers,
      handleChange: handleAnswerChange,
      handleDone,
      editMode,
      loading,
      isFetching,
    } = useCertification(
      "Continual Improvement", // section
      {},                    // initialAnswers
      questionnaireId        // questionnaireId (optional)
    );


  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  return (
    <div
      className={`${classes.wrapper} ${!editMode ? classes.fromParams : ""}`}
    >
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">Section 11: Continual Improvement {questionnaireId && "(Editing)"}</h2>
      </div>

      {isFetching || loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(
            handleAnswerChange,
            answers,
            editMode
          )}

          <CommonFooter
            handlePrevious={handlePrevious}
            handleCancel={() => navigate(-1)}
            handleNext={handleNext}
            handleDone={handleDone}
            questionSets={questionSets}
            currentSet={currentSet}
            cancelText="Cancel"
            doneText={
              questionnaireId ? "Update Assessment" : "Submit Assessment"
            }
          />
        </>
      )}
    </div>
  );
};

export default AddContinualImprovement;
